// Loads the Google Maps JS API on demand instead of blocking every page.
// Safe to call many times: the script is injected once and the same promise is shared.
const MAPS_KEY = process.env.RAZZLE_GOOGLE_MAPS_KEY || 'AIzaSyBAUAJTh9g3BkmLxwpo0OMWHipeEx6RskI';
const CALLBACK = '__onGoogleMapsLoaded';

let mapsPromise = null;

const isReady = () =>
    typeof window !== 'undefined' && !!(window.google && window.google.maps && window.google.maps.places && window.google.maps.geometry);

export function loadGoogleMaps() {
    if (typeof window === 'undefined') {
        return new Promise(() => {}); // never resolves on the server
    }
    if (isReady()) {
        return Promise.resolve(window.google);
    }
    if (!mapsPromise) {
        mapsPromise = new Promise((resolve, reject) => {
            window[CALLBACK] = () => resolve(window.google);
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_KEY}&libraries=places,geometry&loading=async&callback=${CALLBACK}`;
            script.async = true;
            script.defer = true;
            script.onerror = () => {
                mapsPromise = null; // allow a retry on the next call
                reject(new Error('Google Maps failed to load'));
            };
            document.head.appendChild(script);
        });
    }
    return mapsPromise;
}
